// export const USER_SYNC_URL = 'viadata.store/tag/sync.php';

export const IFRAME_IS_NOT_ALLOW_FALLBACK = '//viadata.store/iframe-not-allow';

export const GOOGLE_IMA_URL = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js'; // https://imasdk.googleapis.com/js/sdkloader/ima3.js
export const GOOGLE_PUB_TAG_URL = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
export const YANDEX_SDK_URL = 'https://an.yandex.ru/system/context.js';
export const YANDEX_ADS_SDK_URL = 'https://yandex.ru/ads/system/adsdk.js';
export const ADMAN_URL = 'https://ad.mail.ru/static/vk-adman.js';
export const GNEZDO_URL = 'https://news.2xclick.ru/loader.min.js';

export const SEGMENT_START_EVENT_URL = 'https://logs.viadata.store/event/content?zone=(zone)&event=start&cid=(cid)&cb=(cb)&sid=(sid)';
export const SEGMENT_CLICK_EVENT_URL = 'https://logs.viadata.store/event/content?zone=(zone)&event=click&cid=(cid)&cb=(cb)&sid=(sid)';

export const STREAM_START_EVENT_URL = 'https://logs.viadata.store/event/stream?zone=(zone)&sid=(sid)&event=start&cid=(content.id)&cb=(cb)';
export const STREAM_COMPLETE_EVENT_URL = 'https://logs.viadata.store/event/stream?zone=(zone)&sid=(sid)&event=complete&cid=(content.id)&cb=(cb)';
export const STREAM_RATE_EVENT_URL = 'https://logs.viadata.store/event/stream?zone=(zone)&sid=(sid)&event=(rate)&cid=(content.id)&cb=(cb)';
export const STREAM_UI_DATA_URL = 'https://pl.viadata.store/stream/?sid=(sid)&zone=(zone)&page=(encoded_page_url)&vid=(video_id)';

export const RANDOM_RUTUBE_CONTENT_URL = 'https://pl.viadata.store/rutube/?sid=(sid)&zone=(zone)&page=(encoded_page_url)&vid=(video_id)';

export const FALLBACK_EVENT_URL = 'https://logs.viadata.store/event/extra?sid=(sid)&zone=(zone)&event=fb&cb=(cb)&n=(views)&tg=(tg)';

export const AD_BEFORE_UNLOAD_DELAY = 2000;
export const AD_BEFORE_COMPLETE_DELAY = 100;
export const AD_FALLBACK_TIMEOUT = 275; // 250

export const YandexHeaderResize = {
  WIDTH: 'width',
  HEIGHT: 'height',
  NONE: 'none',
};

export const PassbackMode = {
  ALWAYS: 'ALWAYS',
  NOADS: 'NOADS',
  NOCLOSE: 'NOCLOSE',
  ONCLOSE: 'ONCLOSE',
  TOGETHER: 'TOGETHER',
}

export const PassbackType = {
  SCRIPT: 'SCRIPT',
}

export const DestroyReason = {
  NOADS: 'NOADS',
  USER_CLOSE: 'USER_CLOSE',
  OTHER: 'OTHER',
  FORCE_STOP: 'FORCE_STOP',
}

export const FloatingType = {
  NONE: 0,
  BOTTOM_ONLY: 1,
  ABOVE_AFTER_START: 2,
  ALWAYS: 3,
};

export const Platform = {
  VPAID: 0,
  YANDEX: 1,
  YANDEX_ADS_SDK: 2,
  GOOGLE: 3,
  ADMAN: 4,
  VK: 5,
  ADFOX: 6,
	GPT: 7,
  GNEZDO: 8,
};

export const StreamDesignLayout = {
  EMPTY: 0,
  LIGHT: 1,
  DEFAULT: 2,
};

export const ContentType = {
  VIDEO: 'video',
  STREAM: 'stream',
  RUTUBE: 'rutube',
  PRELOADER: 'preloader',
  NONE: 'none',
  TAGS: 'tags',
}

export const SegmentsType = {
  SLIDESHOW: 'slideshow',
  VIDEO: 'video',
};

export const SegmentsMode = {
  FORCED: 'forced',
  PRE: 'pre',
  FF: 'ff',
  OLD: 'old',
};

export const MediaType = {
  MP4: "video/mp4",
  JS: "application/javascript",
};

export const APICallMethod = {
  FETCH: 'fetch',
  IMAGE: 'image',
};

export const AdFormat = {
  ALL: "all",
  MIDROLL: "midroll",
  PREROLL: "preroll",
  GOOGLE: "google",
  BANNER: "banner",
};

export const event = {
  Player: {
    TagCompleteRequest: 'TagCompleteRequest',
    AdPreloaded: 'AdPreloaded',
    AdUnitFinished: 'AdUnitFinished',
    AdPauseRequest: 'AdPauseRequest',
    AdResumeRequest: 'AdResumeRequest',
    AdStartRequest: 'AdStartRequest',
    AdResizeRequest: 'AdResizeRequest',
    AdSkipRequest: 'AdSkipRequest',
    AdStopRequest: 'AdStopRequest',
    AdRemoveFromQueueRequest: 'AdRemoveFromQueueRequest',
    PlayerDestroyRequest: 'PlayerDestroyRequest',
    PlayerLoaded: 'PlayerLoaded',
    PlayerLog: 'PlayerLog',
    PlayerVisibilityChangeRequest: 'PlayerVisibilityChangeRequest',
    PlayerVisibilityChanged: 'PlayerVisibilityChanged',
    ContentInit: 'ContentInit',
    ContentStarted: 'ContentStarted',
    ContentFinished: 'ContentFinished',
    ContentStartRequest: 'ContentStartRequest',
    ContentFinishRequest: 'ContentFinishRequest',
    ContentPauseRequest: 'ContentPauseRequest',
    ContentResumeRequest: 'ContentResumeRequest',
    ContentResumed: 'ContentResumed',
    ContentPaused: 'ContentPaused',
    ContentUpdate: 'ContentUpdate',
    UserInteractedWithUI: 'UserInteractedWithUI',
    UserInteractedWithCloseButton: 'UserInteractedWithCloseButton',
    UserInteractedWithSoundButton: 'UserInteractedWithSoundButton',
    YandexAdStarted: 'YandexAdStarted',
    YandexAdFinished: 'YandexAdFinished',
    YandexInstreamStarted: 'YandexInstreamStarted',
    ReRequestStatusChangeRequest: 'ReRequestStatusChangeRequest',
    TagsRequest: 'TagsRequest',
    ExpandRequest: 'ExpandRequest',
    AdUnitStatusChanged: 'AdUnitStatusChanged',
    QueueManagerStatusChangeRequest: 'QueueManagerStatusChangeRequest',
    QueueManagerStatusChanged: 'QueueManagerStatusChanged',
    OnNoAds: 'OnNoAds',
    SocketConntectionUpdate: 'SocketConntectionUpdate',
    ViewabilityStatusChanged: 'ViewabilityStatusChanged',
    SkipPreviewImageChange: 'SkipPreviewImageChange',
    ViewabilityLog: 'ViewabilityLog',
    RefreshPlayerCheckAliveTimer: 'RefreshPlayerCheckAliveTimer',
    OnFloatingClose: 'OnFloatingClose',
    ResizeAllAds: 'ResizeAllAds',
    ToggleControls: 'ToggleControls',
    RefreshYandexRTBScope: 'RefreshYandexRTBScope',
    RefreshAdmanScope: 'RefreshAdmanScope',
    ClearEmbedContentFallback: 'ClearEmbedContentFallback',
    RefreshIFrameScope: 'RefreshIFrameScope',
  },
  Ad: {
    AdLoaded: 'AdLoaded',
    AdStarted: 'AdStarted',
    AdError: 'AdError',
    AdImpression: 'AdImpression',
    AdVideoComplete: 'AdVideoComplete',
    AdSkipped: 'AdSkipped',
    AdSkippableStateChange: 'AdSkippableStateChange',
    AdStopped: 'AdStopped',
    AdClosed: 'AdClosed',
    AdUserClose: 'AdUserClose',
    AdVideoStart: 'AdVideoStart',
    AdVideoFirstQuartile: 'AdVideoFirstQuartile',
    AdVideoMidpoint: 'AdVideoMidpoint',
    AdVideoThirdQuartile: 'AdVideoThirdQuartile',
    AdClickThru: 'AdClickThru',
    AdVolumeChange: 'AdVolumeChange',
    AdVolumeMuteExtra: 'AdVolumeMuteExtra',
    AdVolumeUnmuteExtra: 'AdVolumeUnmuteExtra',
    AdPaused: 'AdPaused',
    AdPlaying: 'AdPlaying',
    AdDurationChange: 'AdDurationChange',
    AllAdComplete: 'AllAdComplete',
  },
  UI: {
    CloseTimerStart: 'CloseTimerStart',
    ResetVolumeState: 'ResetSoundState',
    HidePoster: 'HidePoster',
  },
  Segments: {
    ProgressPartComplete: 'ProgressPartComplete',
    VideoComplete: 'VideoComplete',
  },
  Stream: {
    BindStreamVideoToUI: 'BindStreamVideoToUI',
    StreamBackgroundClicked: 'StreamBackgroundClicked',
    StartSkipTimer: 'StartSkipTimer',
    HideSkipButton: 'HideSkipButton',
  },
  TagsContent: {
    Play: 'TagsContentPlay',
    ClearTagsContentFallback: 'ClearTagsContentFallback',
    EmitEvent: 'EmitEvent',
  }
}

export const YandexRTBType = {
  video: 'video',
  banner: 'banner'
}

export const PrerollDelayState = {
  IDLE: 0,
  DELAY_SEGMENT_PLAYED: 1,
  REGULAR_SEGMENT_PLAYED: 2,
}

export const PlayerType = {
  SLIDER: 'slider',
  INTERSTITIAL: 'interstitial',
  INPAGE: 'inpage',
  FLOATING: 'floating',
  INTERSCROLLER: 'interscroller',
  STREAM: 'stream',
  EMBED: 'embed',
};

export const AdvIDPrefix = {
  YANDEX: 'ya_',
  YANDEX_INSTREAM: 'yains_',
  YANDEX_BANNER: 'yaban_',
  ADFOX: 'adfox_',
  ADMAN: 'adman_',
  GOOGLE: 'goog_',
	GPT: 'gpt_',
  VPAID: 'vpd_',
  VAST: 'vst_',
  GNEZDO: 'gnzd_'
};

export const OnNoAds = {
  NONE: '',
  STOP: 'stop',
  HIDE: 'hide',
}

export const Multiads = {
  DISABLED: 0,
  ALLOWED: 1,
};

export const INTERSCROLLER_HIDING_MODE = {
  ALLOWED: 0,
  DISABLED: 1,
};

export const eventAssociator = {
  [event.Ad.AdVideoStart]: 'start',
  [event.Ad.AdImpression]: 'impression',
  [event.Ad.AdVideoFirstQuartile]: 'firstQuartile',
  [event.Ad.AdVideoMidpoint]: 'midpoint',
  [event.Ad.AdVideoThirdQuartile]: 'thirdQuartile',
  [event.Ad.AdVideoComplete]: 'complete',
  [event.Ad.AdPaused]: 'pause',
  [event.Ad.AdPlaying]: 'resume',
  [event.Ad.AdSkipped]: 'skip',
  [event.Ad.AdClosed]: 'close',
  [event.Ad.AdClickThru]: 'click',
  [event.Ad.AdError]: 'error',
  [event.Player.ViewabilityLog]: 'vis',

  [event.Ad.AdVolumeMuteExtra]: 'muteExtra',
  [event.Ad.AdVolumeUnmuteExtra]: 'unmuteExtra',
};

export const TrackingContentEvent = {
  START: 'start',
  COMPLETE: 'complete'
}

export const AdUnitStatus = {
  INIT: 'init',
  LOADED: 'loaded',
  ACTIVE: 'active',
  PLAYING: 'playing',
  PAUSED: 'paused',
  FINISHED: 'finished',
  ERROR: 'error',
};

export const QueueManagerStatus = {
  IDLE: 'idle',
  READY_TO_PLAY: 'readyToPlay',
  WAIT_FOR_READY_TAGS: 'waitForReadyTags',
  WAIT_FOR_VIEW: 'waitForView',
  WAIT_FOR_USER_PLAY: 'waitForUserPlay',
  PLAYING: 'playing',
  CONTENT_PLAYING: 'contentPlaying',
  MAX_IMPRESSION: 'maxImpression',
  MAX_RUN: 'maxRun',
};

export const TagsGroup = {
  ZERO: 0,
  YANDEX: 1,
  ADMAN: 2,
  IN_PROCESS: 3,
  CONTENT: 4,
}

export const FrequencyMode = {
  ALWAYS: 0,
  AFTER_PLAYING: 1,
}

export const IFrameScopeName = {
  YANDEX: 'yandexRTBScope',
  ADMAN: 'admanScope',
  YANDEX_CONTENT: 'contentYandexRTBScope',
  ADMAN_CONTENT: 'contentAdmanScope',
}

export const OVERLAP_CHECKING_STEP = 65;
export const YANDEX_HEADER_HEIGHT = 44;
export const SWIPER_REQUIRED_DISTANCE = 100;

export const ACTIVE_UNIT_STATUSES = [AdUnitStatus.PLAYING, AdUnitStatus.PAUSED, AdUnitStatus.ACTIVE];
